import { render, staticRenderFns } from "./SPIFManageInputs.vue?vue&type=template&id=77beaad7"
import script from "./SPIFManageInputs.vue?vue&type=script&lang=js"
export * from "./SPIFManageInputs.vue?vue&type=script&lang=js"
import style0 from "./SPIFManageInputs.vue?vue&type=style&index=0&id=77beaad7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports